import type { NegotiationVariable } from '../core/define'
import { defineObjectGroup } from '../core/define-object-group'

/**
 * Ubicación de la negociación (objeto `place` → país/departamento/municipio).
 *
 * Los valores YA vienen resueltos a NOMBRE (no código): el orquestador hace el lookup en los
 * catálogos y los deja en `ctx.lugar`. Por eso el `value` de cada opción del dominio también es el
 * nombre — así la comparación coincide.
 *
 * El metadato está en `@idc-forms/schemas/variables/document/lugar.variables`; las tres listas las
 * aporta el host (`HOST_ENUM_VALUES`), porque salen de 170 KB de JSON del bundle de la web.
 */
export const LUGAR_VARIABLES: NegotiationVariable[] = defineObjectGroup('lugar', {
  pais: (c) => c.lugar?.pais ?? '',
  departamento: (c) => c.lugar?.departamento ?? '',
  municipio: (c) => c.lugar?.municipio ?? ''
})
